import {
  makePaginationState,
  makeOffesetPaginationState,
  STATUSES,
  concatUnique,
} from 'app/utils/redux';

import * as t from './types';

const initialState = {
  followingUsers: makePaginationState(),
  followingUserStories: makePaginationState(),
  readStories: makeOffesetPaginationState(),
  feeds: makePaginationState(),
};

const _likeCommunityPostIterator = (item, id) => {
  if (item.objectId === parseInt(id, 10) && item.objectType === 'community') {
    return {
      ...item,
      object: {
        ...item.object,
        isLiked: !item.object.isLiked,
        likeCount: item.object.isLiked
          ? item.object.likeCount - 1
          : item.object.likeCount + 1,
      },
    };
  }

  return item;
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch following users
    case `${t.FETCH_FOLLOWING_USERS}_PENDING`:
      return {
        ...state,
        followingUsers: {
          ...state.followingUsers,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_FOLLOWING_USERS}_SUCCESS`:
      return {
        ...state,
        followingUsers: {
          ...state.followingUsers,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.followingUsers.pagination.items,
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_FOLLOWING_USERS}_ERROR`:
      return {
        ...state,
        followingUsers: {
          ...state.followingUsers,
          status: STATUSES.ERROR,
        },
      };

    // fetch following users stories
    case `${t.FETCH_FOLLOWING_USER_STORIES}_PENDING`:
      return {
        ...state,
        followingUserStories: {
          ...state.followingUserStories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_FOLLOWING_USER_STORIES}_SUCCESS`:
      return {
        ...state,
        followingUserStories: {
          ...state.followingUserStories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.followingUserStories.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_FOLLOWING_USER_STORIES}_ERROR`:
      return {
        ...state,
        followingUserStories: {
          ...state.followingUserStories,
          status: STATUSES.ERROR,
        },
      };

    case `${t.FETCH_FOLLOWING_FEEDS}_PENDING`:
      return {
        ...state,
        feeds: {
          ...state.feeds,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_FOLLOWING_FEEDS}_SUCCESS`:
      return {
        ...state,
        feeds: {
          ...state.feeds,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.feeds.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_FOLLOWING_FEEDS}_ERROR`:
      return {
        ...state,
        feeds: {
          ...state.feeds,
          status: STATUSES.ERROR,
        },
      };

    case t.SET_FOLLOWING_FEEDS_DATA: {
      const { data, feedType } = action;
      return {
        ...state,
        feeds: {
          ...state.feeds,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...state.feeds.pagination,
            items: state.feeds.pagination.items.map((item) => {
              if (item.object) {
                return item;
              }

              const object = data.find(
                (d) => d.id === item.objectId && item.objectType === feedType
              );

              if (object) {
                return {
                  ...item,
                  object,
                };
              }

              return item;
            }),
          },
        },
      };
    }

    case t.RESET_FOLLOWING_FEEDS:
      return {
        ...state,
        feeds: makePaginationState(),
      };

    // fetch read stories
    case `${t.FETCH_READ_STORIES}_PENDING`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_READ_STORIES}_SUCCESS`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.readStories.pagination.items,
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_READ_STORIES}_ERROR`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.ERROR,
        },
      };

    case `${t.DELETE_READ_STORY}_SUCCESS`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          pagination: {
            ...state.readStories.pagination,
            items: state.readStories.pagination.items.filter(
              (item) => item.id !== action.meta.id
            ),
          },
        },
      };

    case `${t.DELETE_READ_STORIES}_SUCCESS`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          pagination: {
            ...state.readStories.pagination,
            items: state.readStories.pagination.items.filter(
              (item) => !action.meta.storyIds.includes(item.id)
            ),
          },
        },
      };

    // change read stories order type
    case `${t.CHANGE_READ_STORIES_ORDER_TYPE}_PENDING`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.CHANGE_READ_STORIES_ORDER_TYPE}_SUCCESS`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: action.payload.result.items,
          },
        },
      };
    case `${t.CHANGE_READ_STORIES_ORDER_TYPE}_ERROR`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.ERROR,
        },
      };

    // like community
    case `${t.LIKE_COMMUNITY_POST}_SUCCESS`: {
      const { postId } = action.meta;
      return {
        ...state,
        feeds: {
          ...state.feeds,
          pagination: {
            ...state.feeds.pagination,
            items: state.feeds.pagination.items.map((item) =>
              _likeCommunityPostIterator(item, postId)
            ),
          },
        },
      };
    }

    // reset
    case t.RESET_FOLLOWING_USERS:
      return {
        ...state,
        followingUsers: makePaginationState(),
      };

    case t.RESET_FOLLOWING_USER_STORIES:
      return {
        ...state,
        followingUserStories: makePaginationState(),
      };

    case t.RESET_READ_STORIES:
      return {
        ...state,
        readStories: makeOffesetPaginationState(),
      };

    default:
      return { ...state };
  }
};
export { initialState };



// WEBPACK FOOTER //
// ./src/app/redux/front/library/reducer.js